export default {"src":"/_next/static/media/twitter.26ab5170.svg","height":13,"width":14};